(function(){
  function init(){
    var modal=document.querySelector('.llsz-modal');
    /* Move the size chart to the top level of the page so no column layout can trap it behind other content. */
    if(modal&&modal.parentNode!==document.body){document.body.appendChild(modal);}
    var picker=document.querySelector('block-variant-picker');
    function showModal(o){if(!modal)return;modal.hidden=!o;document.documentElement.style.overflow=o?'hidden':'';if(o)modal.querySelector('.llsz-x').focus();}
    if(modal&&picker){
      var labels=[].slice.call(picker.querySelectorAll('.variant__label, legend'));
      var sizeLabel=labels.filter(function(l){return /^\s*size/i.test(l.textContent)})[0];
      if(sizeLabel&&!sizeLabel.querySelector('[data-sizeguide]')){
        var a=document.createElement('a');a.href='#';a.className='lls-link';a.setAttribute('data-sizeguide','');a.textContent="What\u2019s my size?";
        sizeLabel.classList.add('lls-head');sizeLabel.appendChild(a);
      }
    }
    document.addEventListener('click',function(e){var t=e.target.closest('[data-sizeguide]');if(!t||!modal)return;e.preventDefault();showModal(true);});
    if(modal){modal.addEventListener('click',function(e){if(e.target===modal||e.target.closest('.llsz-x'))showModal(false)});
      document.addEventListener('keydown',function(e){if(e.key==='Escape'&&!modal.hidden)showModal(false)});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

(function(){
  function run(){
    var data=document.getElementById('llp-prices'); if(!data) return;
    var prices; try{prices=JSON.parse(data.textContent)}catch(e){return}
    var form=document.querySelector('.product-single__meta form[action*="/cart/add"]')||document.querySelector('form[action*="/cart/add"]');
    function btn(){return document.querySelector('.product-single__meta button[name="add"]')}
    function idVal(){var i=document.querySelector('.product-single__meta [name="id"]')||(form&&form.querySelector('[name="id"]'));return i?i.value:null}
    function sync(){
      var b=btn(); if(!b) return;
      var p=prices[idVal()]||prices._default; if(!p) return;
      var s=b.querySelector('.llp-btnprice');
      if(!s){s=document.createElement('span');s.className='llp-btnprice';(b.querySelector('span')||b).appendChild(s);}
      s.textContent=' \u2014 '+p;
    }
    sync();
    document.addEventListener('change',function(){setTimeout(sync,60);setTimeout(sync,400)});
    document.addEventListener('click',function(e){if(e.target.closest('block-variant-picker')){setTimeout(sync,60);setTimeout(sync,400)}});
    var b=btn(); if(b&&window.MutationObserver){new MutationObserver(function(){var b2=btn();if(b2&&!b2.querySelector('.llp-btnprice'))sync()}).observe(b,{childList:true,subtree:true,characterData:true})}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
})();

/* Size/option buttons: if a tap lands on the visible button instead of the hidden selector, select it anyway */
(function(){
  document.addEventListener('click',function(e){
    var lab=e.target.closest('.variant-button-wrap .element-radio');if(!lab)return;
    var inp=lab.querySelector('input[type=radio]');
    if(!inp||inp.disabled||inp.checked||e.target===inp)return;
    inp.checked=true;
    inp.dispatchEvent(new Event('input',{bubbles:true}));
    inp.dispatchEvent(new Event('change',{bubbles:true}));
  },true);
})();
